/**
 * Canonical trigger-job payload (WSRADM-0025).
 *
 * Shared by `POST /admin/reports/rebuild` and dimension PUT `build`. Wire shape
 * is `{ id, status, jobType, alreadyInFlight }` — there is no `jobId`.
 */
import { asBoolean, asNumber, asText, isObject } from '@/api/parse';

export interface TriggerJobResponse {
  id: number;
  status: string;
  jobType: string;
  alreadyInFlight: boolean;
}

/**
 * Total. Returns null when `raw` is not an object or when `asNumber(raw.id)` is null;
 * `status` and `jobType` default to '' via `asText(...) ?? ''`;
 * `alreadyInFlight` is `asBoolean(...) ?? false`.
 */
export function parseTriggerJobResponse(raw: unknown): TriggerJobResponse | null {
  if (!isObject(raw)) return null;
  const id = asNumber(raw['id']);
  if (id === null) return null;
  return {
    id,
    status: asText(raw['status']) ?? '',
    jobType: asText(raw['jobType']) ?? '',
    alreadyInFlight: asBoolean(raw['alreadyInFlight']) ?? false,
  };
}
